<script>
export default {
  components: {},
  props: {
    value: {
      type: [String, Number, Array],
      default: null
    },
    label: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      options: []
    };
  },
  computed: {
    selectedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  mounted() {
    this.initOptions();
  },
  methods: {
    initOptions() {
      this.loading = true;
      this.$store.dispatch('bu_costItem/fetchOptions', {
        page: 1,
        size: 999
      }).then(res => {
        this.options = res.data.records || [];
      }).finally(() => {
        this.loading = false;
      });
    },
    onChange(val) {
      if (Object.hasOwn(this.$attrs, 'multiple')) {
        const selectedItems = val.map(item => this.options.find(option => option.id === item));
        this.$emit('change', selectedItems);
      } else {
        const selectedItem = this.options.find(item => item.id === val);
        this.$emit('change', selectedItem);
      }
    }
  }
}
</script>

<template>
  <el-select
    v-model="selectedValue"
    :loading="loading"
    v-bind="$attrs"
    @change="onChange"
    filterable
    default-first-option
    clearable
    style="width: 100%;"
  >
    <el-option
      v-for="item in options"
      :key="item.id+item.costItemName"
      :label="item.costItemName"
      :value="item.id"
    >
      <div>
        <div class="flex justify-between">
          <div>
            <span>{{ item.costItemName }}</span>
          </div>
          <div>
            <span class="label">税率：</span>
            <span>{{ _.isNil(item.costItemTaxRate) ? '-' : item.costItemTaxRate }}%</span>
          </div>
        </div>
      </div>
    </el-option>
  </el-select>
</template>

<style scoped lang="scss">
.label {
  font-size: 12px;
  color: var(--color-text-3);
}
</style>
